import { render, staticRenderFns } from "./detailPage.html?vue&type=template&id=0bbdb897&scoped=true&external"
import script from "./detailPage.js?vue&type=script&lang=js&external"
export * from "./detailPage.js?vue&type=script&lang=js&external"
import style0 from "./detailPage.styl?vue&type=style&index=0&id=0bbdb897&prod&lang=styl&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbdb897",
  null
  
)

export default component.exports